import { IonButton, IonContent, IonInput, IonPage, IonSpinner, IonToast } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";
import AdminGoogleButton from "../components/AdminGoogleButton.jsx";
import AuthDivider from "../components/AuthDivider.jsx";
import FormNotice from "../components/FormNotice.jsx";
import PasswordField from "../components/PasswordField.jsx";

const blankForm = {
  email: "",
  password: "",
};

export default function AdminSignInPage() {
  const { signInAdminWithPassword, loginWithGoogleCredential } = useAuth();
  const history = useHistory();
  const [form, setForm] = useState(blankForm);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";
  const isGoogleConfigured = googleClientId && !googleClientId.includes("local-google-client-id") && !googleClientId.includes("missing");

  async function handleGoogle(response) {
    try {
      await loginWithGoogleCredential(response);
      history.replace("/app/schedule");
    } catch (err) {
      setError(err.message);
    }
  }

  async function submit() {
    try {
      setIsSubmitting(true);
      await signInAdminWithPassword(form);
      history.replace("/app/schedule");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <IonPage>
      <IonContent fullscreen className="auth-screen">
        <div className="auth-card">
          <div className="auth-copy auth-copy-center">
            <img className="auth-logo" src="/branding/metora-logo.png" alt="Metora logo" />
            <h1>Sign In</h1>
            <p>Welcome back! Please sign in.</p>
          </div>

          <div className="auth-form">
            <IonInput
              className="metora-input"
              label="Admin Email"
              labelPlacement="stacked"
              type="email"
              placeholder="name@yourbusiness.com"
              value={form.email}
              onIonInput={(event) => setForm({ ...form, email: event.detail.value ?? "" })}
            />
            <PasswordField
              label="Password"
              value={form.password}
              visible={showPassword}
              placeholder="Enter your password"
              onIonInput={(event) => setForm({ ...form, password: event.detail.value ?? "" })}
              onToggleVisibility={() => setShowPassword((value) => !value)}
            />
            {Boolean(error) && <FormNotice tone="error">{error}</FormNotice>}
            <IonButton fill="clear" className="auth-inline-link" onClick={() => setError("Password reset is not available yet.")}>
              Forgot password?
            </IonButton>
            <IonButton expand="block" disabled={isSubmitting || !form.email || !form.password} onClick={submit}>
              {isSubmitting && <IonSpinner name="crescent" className="button-spinner" />}
              Sign In
            </IonButton>
          </div>

          <AuthDivider />
          <AdminGoogleButton
            isConfigured={isGoogleConfigured}
            onSuccess={handleGoogle}
            onError={() => setError("Google login failed")}
          />

          <IonButton expand="block" fill="clear" className="auth-link-button" onClick={() => history.push("/login/create")}>
            Don&apos;t have an account? Create Account
          </IonButton>
        </div>
        <IonToast isOpen={Boolean(error)} message={error} duration={2500} onDidDismiss={() => setError("")} />
      </IonContent>
    </IonPage>
  );
}
